import toast from 'react-hot-toast';
import { useFeedStore } from '@/app/store/feedStore';

export const useProcessFeeds = () => {
  const processRssFeeds = useFeedStore((state) => state.processRssFeeds);
  const isLoading = useFeedStore((state) => state.isLoading);

  const processFeeds = async () => {
    const result = await processRssFeeds();

    if (result == null) {
      const message = useFeedStore.getState().error ?? 'Failed to process RSS feeds';
      useFeedStore.getState().clearError();
      toast.error(message);
      return;
    }

    if (result.errors.length > 0) {
      toast(`Completed with ${result.errors.length} error(s)`, { icon: '⚠️' });
      return;
    }

    if (result.newItemsAdded === 0) {
      toast('No new items found');
      return;
    }

    toast.success(`${result.newItemsAdded} new item(s) added — classifying in the background…`);
  };

  return { processFeeds, isProcessing: isLoading };
};
